/**
 * Scroll progress (0 as the statement enters, 1 as it leaves) to how much of
 * it is lit. Lighting runs from 15% to 55% of the pass, so the line is fully
 * lit while it sits mid-screen.
 */
export const getLitAmount = (progress: number, start = 0.15, end = 0.55) =>
  Math.min(1, Math.max(0, (progress - start) / (end - start)));
